import styled from 'styled-components';
import { Button } from '../../../../GlobalComponents/Button';
import { Flex } from '../../../../GlobalComponents/Flex';
import { useNavigate } from 'react-router-dom';
import rewardsImage from '../../../../assets/imgs/banner/rewards.png';

export const LoginPage: React.FC = () => {
	const navigate = useNavigate();
	return (
		<LoginContainer>
			<img
				src={rewardsImage}
				alt="sign in"
				style={{ objectFit: 'fill', width: '100vw', margin: '0 -16px' }}
			/>
			<Flex
				$flexDirection="column"
				$justifyContent="space-evenly"
				$placeContent="flex-start space-around"
			>
				<Flex
					$flexDirection="column"
					$placeContent="flex-start space-between"
					$alignItems="flex-start"
					$rowGap="24px"
					$padding="40px 0"
				>
					<Flex
						$flexDirection="column"
						$placeContent="flex-start"
						$rowGap="8px"
					>
						<Title>Get energized, get rewarded</Title>
						<SubTitle>
							Sign in to your BIGGBY account or join our rewards
							program and earn points, redeem free drinks, and
							scan to pay for speedy checkouts!
						</SubTitle>
					</Flex>
					<Flex $justifyContent="flex-end">
						<Button
							onClick={() => navigate('/login?redirect=/scan')}
						>
							Sign in
						</Button>
					</Flex>
				</Flex>
			</Flex>
		</LoginContainer>
	);
};

const LoginContainer = styled.div`
	/* padding: 16px 0 16px 0; */
`;
const Title = styled.div`
	font-size: 24px;
	font-weight: 500;
`;

const SubTitle = styled.div`
	font-size: 14px;
	font-weight: 500;
`;

// const LightTitle = styled.div`
// 	color: #fdfdfd;
// 	font-size: 20px;
// 	font-weight: 500;
// `;

// const LightSubTitle = styled.div`
// 	color: #fdfdfd;
// 	font-size: 14px;
// 	font-weight: 500;
// `;
